import { Container } from 'react-bootstrap';
import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import OrganizationDocumentOrganism from '../../organisms/OrganizationsDocumentsOrganism/OrganizationDocumentOrganism';
import { BuyerDocumentResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-document-response.dto';
import { FileMeta } from '../../../store/mediaAPI/document/dto/request/document-save-request';
import cn from 'classnames';
import styles from './OrganizationDocumentsTemplate.module.css';
import { UploadDocumentOrganism } from '../../organisms';
import OrganizationBaseEditTemplate from '../../../templates/OrganizationBaseEditTemplate';

interface OrganizationDocumentsTemplateProps {
  documents: BuyerDocumentResponseDto[];
  handleDelete: (id: string) => void;
  handleDownload: (id: string) => void;
  handleEdit: (id: string) => void;
  handleFileMetaOnChange: (fileMeta: FileMeta) => void;
  handleFileOnChange: (file: string) => void;
  handleFileNameOnChange: (name: string) => void;
  callbackFn: () => void;
}

const OrganizationDocumentsTemplate: FC<OrganizationDocumentsTemplateProps> = ({
  documents,
  handleDelete,
  handleDownload,
  handleEdit,
  handleFileMetaOnChange,
  handleFileOnChange,
  handleFileNameOnChange,
  callbackFn,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <OrganizationBaseEditTemplate>
          <div className={cn(styles.tableWrapper)}>
            <OrganizationDocumentOrganism
              documents={documents}
              handleDelete={handleDelete}
              handleDownload={handleDownload}
              handleEdit={handleEdit}
            />
          </div>
          <UploadDocumentOrganism
            setFile={(file) => handleFileOnChange(file)}
            setFileMeta={(fileMeta) => handleFileMetaOnChange(fileMeta)}
            setName={(name) => handleFileNameOnChange(name)}
            callbackFn={callbackFn}
          />
        </OrganizationBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default OrganizationDocumentsTemplate;
